import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "step1", "step2", "step3", "step4",
    "step1indicator", "step2indicator", "step3indicator", "step4indicator",
    "previousButton", "nextButton", "submitButton"
  ]

  connect() {
    this.currentStep = 1
    this.updateButtons()
    this.initializeSteps()
  }

  initializeSteps() {
    for (let i = 2; i <= 4; i++) {
      const indicator = this[`step${i}indicatorTarget`]
      indicator.querySelector('div').classList.add('bg-transparent')
      indicator.querySelector('p').classList.add('text-white/60')
    }
  }

  nextStep(event) {
    event.preventDefault()
    
    if (this.validateCurrentStep()) {
      // Hide current step
      this[`step${this.currentStep}Target`].classList.add('hidden')
      
      // Remove active state from current step
      const currentIndicator = this[`step${this.currentStep}indicatorTarget`]
      currentIndicator.querySelector('div').classList.remove('bg-blue-600', 'border-blue-600', 'text-white')
      currentIndicator.querySelector('div').classList.add('border-white/20', 'bg-transparent', 'text-white/60')
      currentIndicator.querySelector('p').classList.remove('text-white')
      currentIndicator.querySelector('p').classList.add('text-white/60')

      // Increment step
      this.currentStep++

      // Show next step
      this[`step${this.currentStep}Target`].classList.remove('hidden')
      
      // Add active state to next step
      const nextIndicator = this[`step${this.currentStep}indicatorTarget`]
      nextIndicator.querySelector('div').classList.add('bg-blue-600', 'border-blue-600', 'text-white')
      nextIndicator.querySelector('div').classList.remove('border-white/20', 'bg-transparent', 'text-white/60')
      nextIndicator.querySelector('p').classList.add('text-white')
      nextIndicator.querySelector('p').classList.remove('text-white/60')

      this.updateButtons()
    }
  }

  previousStep(event) {
    event.preventDefault()
    
    // Remove active state from current step
    const currentIndicator = this[`step${this.currentStep}indicatorTarget`]
    currentIndicator.querySelector('div').classList.remove('bg-blue-600', 'border-blue-600', 'text-white')
    currentIndicator.querySelector('div').classList.add('border-white/20', 'bg-transparent', 'text-white/60')
    currentIndicator.querySelector('p').classList.remove('text-white')
    currentIndicator.querySelector('p').classList.add('text-white/60')

    this[`step${this.currentStep}Target`].classList.add('hidden')
    this.currentStep--

    // Add active state to previous step
    const prevIndicator = this[`step${this.currentStep}indicatorTarget`]
    prevIndicator.querySelector('div').classList.add('bg-blue-600', 'border-blue-600', 'text-white')
    prevIndicator.querySelector('div').classList.remove('border-white/20', 'bg-transparent', 'text-white/60')
    prevIndicator.querySelector('p').classList.add('text-white')
    prevIndicator.querySelector('p').classList.remove('text-white/60')

    this[`step${this.currentStep}Target`].classList.remove('hidden')
    this.updateButtons()
  }

  updateButtons() {
    this.previousButtonTarget.classList.toggle('hidden', this.currentStep === 1)
    this.nextButtonTarget.classList.toggle('hidden', this.currentStep === 4)
    this.submitButtonTarget.classList.toggle('hidden', this.currentStep !== 4)
  }

  validateCurrentStep() {
    const currentStep = this[`step${this.currentStep}Target`]
    const requiredFields = currentStep.querySelectorAll('input[required]')
    let isValid = true

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        isValid = false
        field.classList.add('border-red-500')
      } else {
        field.classList.remove('border-red-500')
      }
    })

    // Special handling for license types on step 3
    if (this.currentStep === 3) {
      const checkedLicenses = currentStep.querySelectorAll('input[type="checkbox"]:checked')
      if (checkedLicenses.length === 0) {
        isValid = false
        // Add visual feedback for license type validation
        currentStep.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
          checkbox.closest('div').classList.add('border-red-500')
        })
      }
    }

    return isValid
  }
} 
